import { ActionsButtons } from "components/ManageMacroModal/styles";
import { Trash2 } from "react-feather";
import { useTheme } from "styled-components";
import { Button } from "styles/Button";
import { Template } from "types/Template";
import { useDeleteTemplate } from "hooks/mutations/useDeleteTemplate";
import Swal from "sweetalert2";
import { MouseEvent } from 'react';

export function TemplateCard({ template }: { template: Template }) {
    const theme = useTheme();
    const deleteTemplate = useDeleteTemplate();

    async function handleDeleteTemplate(e: MouseEvent, template: Template) {
        e.stopPropagation();

        const willDelete = await Swal.fire({
            title: 'Excluir template!',
            text: 'Tem certeza que deseja excluir este template? Esta ação também o removerá da Meta.',
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: 'Cancelar',
            showConfirmButton: true,
            confirmButtonText: 'Excluir template',
            confirmButtonColor: theme.colors.danger,
            reverseButtons: true,
        });

        if (!willDelete.isConfirmed) return;

        await deleteTemplate.mutateAsync({ template });
    }

    return (
        <>
            <tr key={template.id}>
                <td>{template.title}</td>
                <td style={{ maxWidth: 300, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {template.message}
                </td>
                <td>{template.manual_send ? 'Sim' : 'Não'}</td>
                <td>
                    <ActionsButtons>
                        <Button onClick={(e) => handleDeleteTemplate(e, template)} small>
                            <Trash2 color={theme.colors.buttonText} size="18" />
                        </Button>
                    </ActionsButtons>
                </td>
            </tr>
        </>
    );
}
